import { AfterContentInit, ChangeDetectorRef, Component, ContentChild, ContentChildren, ElementRef, EventEmitter,
  HostBinding, Input, NgZone, OnDestroy, OnInit, Output, QueryList, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WindowRef } from '@duoduo-oba/ng-devui/window-ref';
import { CellSelectedEventArg, CheckableRelation, ColumnResizeEventArg, DataTablePager, RowCheckChangeEventArg,
  RowSelectedEventArg, SortEventArg, TableExpandConfig } from './data-table.model';
import { DataTableColumnTmplComponent } from './tmpl/data-table-column-tmpl.component';
import { DataTableFootTmplComponent } from './tmpl/data-table-foot-tmpl.component';
import { DataTableHeadTmplComponent } from './tmpl/data-table-head-tmpl.component';
import { DataTablePagerTmplComponent } from './tmpl/data-table-pager-tmpl.component';

@Component({
  selector: 'd-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: [
    './data-table.component.scss',
    './data-table.component.color.scss'
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'dataTable'
})
export class DataTableComponent implements OnDestroy, OnInit, AfterContentInit {
  /**
   * ãå¯éãDatatableæ¯å¦æä¾å¾éè¡çåè½
   */
  @Input() checkable: boolean;
  /**
   * ãå¯éãæ¯å¦æä¾æ¾ç¤ºè¡è¯¦æçåè½
   */
  @Input() showExpandToggle: boolean;
  /**
   * ãå¯éãæ¯å¦åºå®è¡¨å¤´ï¼å¨è¡¨æ ¼è¶è¿å®¹å¨æå¤§é«åº¦æ¶ï¼è¡¨æ ¼å¯æ»å¨æ¶çæï¼
   */
  @Input() fixHeader: boolean;
  /**
   * ãå¯éãè¡¨æ ¼å¨è¶åºå®¹å¨æ¶ï¼æ¯å¦å¯ä»¥éè¿æ»å¨æ¥çè¡¨æ ¼åå®¹
   */
  @Input() scrollable: boolean;
  /**
   * ãå¯éãé»è®¤è¡¨æ ¼ä½¿ç¨çè¡¨æ ¼ç±»åï¼å¯éå¼ä¸º'cell'
   */
  @Input() editModel = 'cell';
  /**
   * ãå¯éãéå¶è¡¨æ ¼æå¤§å®½åº¦ï¼é»è®¤ææ»¡ç¶å®¹å¨
   */
  @Input() maxWidth: string;
  /**
   * ãå¯éãéå¶æå¤§é«åº¦ï¼é»è®¤
   */
  @Input() maxHeight: string;
  /**
   * è¡¨æ ¼ç±»å,stripedè¡¨ç°ä¸ºæ¡çº¹é´é
   */
  @Input() type: '' | 'striped' = '';
  /**
   * è¡¨æ ¼æ¯å¦å¼å¯é¼ æ hoverè¡é«äº®ææ
   */
  @Input() hover = true;
  /**
   * è¡¨æ ¼èªå®ä¹æ ·å¼
   */
  @Input() cssClass: string;
  /**
   * è¡¨æ ¼å®½åº¦
   */
  @Input() tableWidth = '100%';
  /**
   * ãå¯éãæ¯å¦éå¶å¤åæåºçè¾åºéå¶ä¸ºä¸é¡¹
   */
  @Input() onlyOneColumnSort: boolean;
  /**
   * ãå¯éãå¤åéæ©æ°ç»ï¼ç¨æ¥æå¯¼é£å åä¼è¢«æåº
   */
  @Input() multiSort: SortEventArg[] = [];
  /**
   * ãå¯éãæ¯å¦å¯ä»¥ææ½è°æ´åå®½
   */
  @Input() resizeable: boolean;
  /**
   * ãå¯éãç¨æ¥èªå®ä¹è¡¨æ ¼æ¯å¦å¯ä»¥æå¨
   */
  @Input() colDraggable: boolean;
  /**
   * ãå¯éãç¨æ¥èªå®ä¹ä¸å¯ææ½çåå å
   */
  @Input() colDropFreezeTo = 0;
  /**
   * ãå¯éãç¨æ¥èªå®ä¹è¯¦æé¡µçæ¨¡æ¿
   */
  @Input() detailTemplateRef: TemplateRef<any>;
  /**
   * ãå¯éãåæ¶ç»å®åå»ãåå»äºä»¶æ¶ï¼ç¨äºåºåç¹å»çæ¶é´é´é,é»è®¤300msï¼ä¸¤ä¸ªäºä»¶ä¸åæ¶ä½¿ç¨å¯ä»¥æå®ä¸º0
   */
  @Input() timeout = 300;
  /**
   * ãå¯éãæ¯å¦æ¾ç¤ºæåºæªæ¿æ´»å¾æ ï¼é»è®¤æ¾ç¤º,
   */
  @Input() showSortIcon = true;
  /**
   * å¤åéæ©Changeäºä»¶ï¼ç¨æ¥æ´æ°å¤åéæ©æ°ç»
   * */
  @Output() multiSortChange = new EventEmitter<SortEventArg[]>();
  /**
   * è¡¨æ ¼ååæ ¼ç¹å»äºä»¶
   */
  @Output() cellClick = new EventEmitter<CellSelectedEventArg>();
  /**
   * è¡¨æ ¼ååæ ¼åå»äºä»¶
   */
  @Output() cellDBClick = new EventEmitter<CellSelectedEventArg>();
  /**
   * è¡¨æ ¼è¡ç¹å»äºä»¶
   */
  @Output() rowClick = new EventEmitter<RowSelectedEventArg>();
  /**
   * è¡¨æ ¼è¡åå»äºä»¶
   */
  @Output() rowDBClick = new EventEmitter<RowSelectedEventArg>();
  /**
  * è¡detail toggleäºä»¶
  */
  @Output() detialToggle = new EventEmitter<any>();
  /**
   * è¡¨æ ¼ååæ ¼å¼å§ç¼è¾åçæ¦æªäºä»¶
   */
  @Input() beforeCellEdit: (rowItem: any, column: any) => Promise<any>;
  /**
   * è¡¨æ ¼ååæ ¼å¼å§ç¼è¾äºä»¶
   */
  @Output() cellEditStart = new EventEmitter<CellSelectedEventArg>();
  /**
   * è¡¨æ ¼ååæ ¼ç»æç¼è¾äºä»¶
   */
  @Output() cellEditEnd = new EventEmitter<CellSelectedEventArg>();
  /**
   * æè¡çå¾éç¶æååäºä»¶
   */
  @Output() rowCheckChange = new EventEmitter<RowCheckChangeEventArg>();
  /**
   * å½åé¡µç å¨å¾éç¶æååäºä»¶
   */
  @Output() checkAllChange = new EventEmitter<boolean>();
  /**
   * é¡µç ååäºä»¶
   */
  @Output() pageIndexChange = new EventEmitter<any>();
  /**
   * å»¶è¿æå è½½å®æäºä»¶
   */
  @Output() loadMore = new EventEmitter();
  /**
   * åå®½ååäºä»¶
   */
  @Output() resize = new EventEmitter<ColumnResizeEventArg>();
  /**
   * å½åè¡¨æ ¼å±çº§ï¼é»è®¤ä¸º0ï¼å¨æ å½¢è¡¨æ ¼åºæ¯ä¸èªå¢é¿
   */
  @Input() tableLevel = 0;
  /**
 * éç½®æ å½¢è¡¨æ ¼çç¶å­éä¸­æ¯å¦äºç¸å³è
 * upwardï¼éä¸­å­å³èç¶
 * downwardï¼ éä¸­ç¶å³èå­
 */
  @Input() checkableRelation: CheckableRelation = { upward: true, downward: true };
  /**
   * å¼æ­¥å è½½å­åè¡¨
   */
  @Input() loadChildrenTable: (rowItem: any) => Promise<any>;
  /**
   * å¼æ­¥å è½½å¨é¨å­åè¡¨
   */
  @Input() loadAllChildrenTable: () => Promise<any>;
  /**
   * æ¯å¦èææ»å¨
   */
  @Input() virtualScroll;
  /**
   * éç½®headerçå±å¼åå®¹
   */
  @Input() headerExpandConfig: TableExpandConfig;
  /**
   * å­åè¡¨å³é­äºä»¶
   */
  @Output() childrenTableClose = new EventEmitter<any>();
  /**
   * å¨é¨å­åè¡¨å³é­äºä»¶
   */
  @Output() allChildrenTableClose = new EventEmitter();

  @ContentChildren(DataTableColumnTmplComponent) columns: QueryList<DataTableColumnTmplComponent>;
  @ContentChild(DataTableHeadTmplComponent, { static: false }) headTemplate: DataTableHeadTmplComponent;
  @ContentChild(DataTableFootTmplComponent, { static: false }) footTemplate: DataTableFootTmplComponent;
  @ContentChild(DataTablePagerTmplComponent, { static: false }) pagerTemplate: DataTablePagerTmplComponent;
  @ContentChild('noResultTemplateRef', { static: false }) noResultTemplate: TemplateRef<any>;
  @ViewChild('fixHeaderContainerRef', { static: false }) fixHeaderContainerRefElement: ElementRef;
  @ViewChild('fixHeaderTableRef', { static: false }) fixHeaderTableRefElement: ElementRef;
  // @ViewChild('fixColumnRef') fixColumnRefElement: ElementRef;
  @ViewChild('tableView', { static: true }) tableViewRefElement: ElementRef;

  _dataSource: any[] = [];
  _pageAllChecked = false;
  selectable = true;
  allChecked: number[] = [];
  _pager: DataTablePager;
  selectedRowItem: any;
  selectedColumnItem: any;
  isCellEdit: boolean;
  editRowItem: any;
  documentClickEvent = new EventEmitter<any>();
  cellEditorClickEvent = new EventEmitter<Event>();
  _hideColumn: string[] = [];
  _columns: DataTableColumnTmplComponent[];
  displayDataSource: any[];
  _lazy = false;
  scrollStream = new EventEmitter<Event>();
  subscription: Subscription;
  colSubscription: Subscription;
  searchQueryChange = new EventEmitter<{ [key: string]: any; }>();
  halfChecked = false;
  tableBodyEl: ElementRef;
  tableStatusEnum = {
    open: true,
    close: false
  };
  resizeBarRefElement: ElementRef;

  private scrollY = 0;
  @ViewChild('resizeBar', { static: false }) set resizeBar(content: ElementRef) {
    setTimeout(() => {
      this.resizeBarRefElement = content;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }


  @Input() set dataSource(dataSource: any[]) {
    if (null === dataSource || !dataSource) {
      dataSource = [];
    }
    this._dataSource = dataSource;
    const hasChecked = this.dataSource.some(this.hasChecked);
    const hasUnChecked = this.dataSource.some(this.hasUnChecked);
    this._pageAllChecked = dataSource && dataSource.length > 0 && !hasUnChecked;
    this.halfChecked = hasChecked && hasUnChecked;
  }

  get dataSource() {
    return this._dataSource;
  }

  @Input() set hideColumn(hideColume: string[]) {
    this._hideColumn = hideColume;
    if (this._columns) {
      this.updateColumns();
    }
  }

  get hideColumn() {
    return this._hideColumn;
  }

  @Input() set pager(pager: DataTablePager) {
    if (pager === undefined || pager === null) {
      return;
    } else {
      this._pager = {
        total: pager.total,
        pageIndex: pager.pageIndex || 1,
        pageSize: pager.pageSize || 10,
        maxItems: pager.maxItems || 8,
        selectDirection: pager.selectDirection || 'auto'
      };
    }
  }

  get pager() {
    return this._pager;
  }

  @Input() set pageAllChecked(pageAllChecked: boolean) {
    if (this.dataSource) {
      this._dataSource = this.setCheckedStatus(this.dataSource, pageAllChecked);
    }
    this._pageAllChecked = pageAllChecked;
    this.halfChecked = this.dataSource.some(this.hasChecked) && this.dataSource.some(this.hasUnChecked);
  }

  get pageAllChecked() {
    return this._pageAllChecked;
  }

  @Input() set lazy(lazy: boolean) {
    this._lazy = lazy;
  }

  get lazy() {
    return this._lazy;
  }

  constructor(
    private windowRef: WindowRef,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private renderer: Renderer2) {
  }

  private getColumns() {
    const cols = this.columns
      .filter(column => {
        return !this.hideColumn.some(field => column.field === field);
      });
    cols.sort((first, second) => first.order - second.order);
    return cols;
  }

  // life hook start
  ngOnInit() {
    if (this.lazy) {
      this.pager = null;
    }
    this.setupScrollEvent();
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener(
        'click',
        this.onDocumentClick.bind(this)
      );
      window.addEventListener(
        'wheel',
        this.onWinScroll.bind(this)
      );
    });
  }

  onDocumentClick($event: Event) {
    this.documentClickEvent.emit($event);
  }

  onWinScroll($event: Event) {
    this.ngZone.run(() => {
      this.scrollStream.emit($event);
    });
  }

  ngAfterContentInit() {
    this.updateColumns();
    this.columns.forEach((col) => {
      col.orderChange.subscribe((order) => {
        this.updateColumns();
      });
    });
    this.columns.changes.subscribe(() => {
      this.updateColumns();
    });
  }

  private updateColumns() {
    this._columns = this.getColumns();
  }

  private getScrollbarWidth() {
    if (this.tableBodyEl) {
      const inner = this.tableBodyEl.nativeElement.parentNode;
      const outer = inner.parentNode;
      // Calculating difference between container's full width and the child width
      return (outer.offsetWidth - inner.offsetWidth);
    }
  }

  ngOnDestroy(): void {
    this.unSubscription();
  }

  onHandleSort(column: SortEventArg) {
    // set column direction
    for (let i = 0; i < this.multiSort.length; i++) {
      if (this.multiSort[i].field === column.field) {
        this.multiSort[i].direction = column.direction;
        break;
      }
    }

    if (this.multiSort) {
      const multiSortIndex = this.multiSort.findIndex(item => item.field === column.field);
      if (multiSortIndex !== -1) {
        this.multiSort.splice(multiSortIndex, 1);
      }

      if (column.direction === '') {
        this.multiSortChange.emit(this.multiSort);
        return;
      }

      if (!this.onlyOneColumnSort) {
        this.multiSort.push(column);
      } else {
        this.multiSort = [column];
      }
    } else {
      this.multiSort = [column];
    }
    this.multiSortChange.emit(this.multiSort);
  }

  onCellClick($event: CellSelectedEventArg) {
    this.selectedRowItem = $event.rowItem;
    this.selectedColumnItem = $event.column;
    this.ngZone.run(() => {
      this.cellClick.emit($event);
    });
  }

  onCellEditStart($event: CellSelectedEventArg) {
    this.isCellEdit = true;
    this.cellEditStart.emit($event);
  }

  onCellEditEnd($event: CellSelectedEventArg) {
    this.isCellEdit = false;
    this.cellEditEnd.emit($event);
  }

  onCellDBClick($event: CellSelectedEventArg) {
    this.ngZone.run(() => {
      this.cellDBClick.emit($event);
    });
  }

  onRowClick($event: RowSelectedEventArg) {
    this.selectedRowItem = $event.rowItem;
    this.ngZone.run(() => {
      this.rowClick.emit($event);
    });
  }

  onRowDBClick($event: RowSelectedEventArg) {
    this.ngZone.run(() => {
      this.rowDBClick.emit($event);
    });
  }

  onDetailToggle($event: any) {
    this.detialToggle.emit($event);
  }

  // å¤æ­æ°æ®æ¯å¦å­å¨éä¸­ç¶æ
  private hasChecked = (data) => {
    if (data.$checked) {
      return true;
    }
    if (data.children) {
      return data.children.some(this.hasChecked);
    }
  }

  // å¤æ­æ°æ®æ¯å¦å­å¨æªéä¸­ç¶æ
  private hasUnChecked = (data) => {
    if (!data.$checked) {
      return true;
    }
    if (data.children) {
      return data.children.some(this.hasUnChecked);
    }
  }

  onRowCheckChange($event: RowCheckChangeEventArg) {
    // å¤çchildrençéä¸­
    if ($event.rowItem.children && this.checkableRelation.downward) {
      this.setCheckedStatus($event.rowItem.children, $event.checked);
    }

    // å¤çparentsçéä¸­
    if (this.checkableRelation.upward) {
      const nestedIndexArray = $event.nestedIndex.split(',');
      nestedIndexArray.shift();
      const nestedIndexArrayToInt = nestedIndexArray.map((value) => {
        // tslint:disable-next-line:radix
        return parseInt(value);
      });
      // éè¿éä¸­è¡çç¶çº§ç´¢å¼è®¾ç½®ç¶çéä¸­ç¶æ
      this.setParentCheckStatus(nestedIndexArrayToInt);
    }

    // å¤çæ´ä¸ªtable headerçéä¸­
    const hasChecked = this.dataSource.some(this.hasChecked);
    if ($event) {
      const hasUnChecked = this.dataSource.some(this.hasUnChecked);
      this._pageAllChecked = !hasUnChecked;
      this.halfChecked = hasChecked && hasUnChecked;
    } else {
      this._pageAllChecked = false;
      this.halfChecked = hasChecked;
    }

    this.rowCheckChange.emit($event);
  }

  private setParentCheckStatus(nestedIndex) {
    if (nestedIndex.length > 0) {
      const topIndex = nestedIndex[0];
      const topParent = this.dataSource[topIndex];
      const argNestedIndex = [...nestedIndex];
      argNestedIndex.shift();
      const lastParent = this.findLastParent(topParent, argNestedIndex);
      this.setSelfCheckStatus(lastParent);

      nestedIndex.pop();
      if (nestedIndex.length > 0) {
        this.setParentCheckStatus(nestedIndex);
      }
    }
  }

  private findLastParent(source, indexArray) {
    if (source && indexArray.length > 0) {
      const topIndex = indexArray[0];
      const topParent = source.children[topIndex];
      indexArray.shift();
      return this.findLastParent(topParent, indexArray);
    } else {
      return source;
    }
  }

  private setSelfCheckStatus(data) {
    if (data && data.children) {
      const hasUnChecked = data.children.some((child) => {
        return !child.$checked;
      });

      const hasChecked = data.children.some((child) => {
        return child.$checked || child.$halfChecked;
      });

      data.$checked = !hasUnChecked;
      data.$halfChecked = hasUnChecked && hasChecked;
    }
  }

  private setCheckedStatus(data, checked) {
    return data.map(item => {
      if (!item.$disabled) {
        item.$checked = checked;
        item.$halfChecked = false;
      }

      if (item.children) {
        item.children = this.setCheckedStatus(item.children, checked);
      }
      return item;
    });
  }

  onCheckAllChange($event: boolean) {
    this.pageAllChecked = $event;
    this.checkAllChange.emit($event);
    // this.changeDetectorRef.markForCheck();
  }

  onSearchQueryChange($event: { [key: string]: any; }) {
    this.searchQueryChange.emit($event);
  }

  onPageChange($event: number) {
    this.pageIndexChange.emit({ pageIndex: $event, pageSize: this.pager.pageSize });
  }

  getSelectedRowItem(): any[] {
    return this.selectedRowItem;
  }


  loadFinish(complete: boolean) {
    if (complete) {
      return this.unSubscription();
    }
    setTimeout(_ => this.onWinScroll(null), 300);
  }


  onScrollChange() {
    const winHeight = this.windowRef.innerHeight;
    const clientRect = this.windowRef.getBoundingClientRect(this.elementRef);
    if (clientRect && winHeight - clientRect.bottom >= 40) {
      this.loadMore.emit(this);
    }
  }

  beginResizeHandlerEvent($event) {
    this.onDocumentClick($event);
  }

  onResizingFixedHandler({ column, width, nextElementWidth }) {
    this._columns = this._columns.map((_column, index) => {
      if (_column.field === column.field) {
        this.ngZone.run(() => {
          if (index + 1 < this._columns.length && this._columns[index + 1].width && _column.width) {
            this._columns[index + 1].width = parseInt(nextElementWidth, 10) + 'px';
          }
          _column.width = width + 'px';
        });

        return _column;
      }
      return _column;
    });
  }

  handleDragTable({ from, to }) {
    const sortArray = (array, fromE, toE) => {
      if (fromE < toE) {
        const fromEData = array[fromE];
        for (let i = 0; i < array.length; i++) {
          if (i >= fromE && i < toE) {
            this.ngZone.run(() => {
              array[i] = array[i + 1];
            });
          }
        }
        this.ngZone.run(() => {
          array[toE] = fromEData;
        });
      }

      if (fromE > toE) {
        const fromEData = array[fromE];
        for (let i = array.length; i > 0; i--) {
          if (i <= fromE && i > toE) {
            array[i] = array[i - 1];
          }
        }
        array[toE] = fromEData;
      }
    };
    sortArray(this._columns, from, to);
    this._columns.forEach((item, index) => {
      item.order = index;
    });
  }

  onResizeHandler($event: { width, field, isUserDefined, nextElementWidth }) {
    const { width, field, isUserDefined, nextElementWidth } = $event;
    this._columns = this._columns.map((column, index) => {
      if (column.field === field) {
        this.ngZone.run(() => {
          if (index + 1 < this._columns.length && this._columns[index + 1].width && column.width) {
            this._columns[index + 1].width = parseInt(nextElementWidth, 10) + 'px';
          }
          column.width = parseInt(width, 10) + 'px';
          const columnResizeEventArg = { currentColumn: column, nextColumn: this._columns[index + 1] };
          this.resize.emit(columnResizeEventArg);
        });
        return column;
      }
      return column;
    });

    this.changeDetectorRef.markForCheck();
  }

  onBodyScroll(event: Event) {
    const target = <HTMLElement>event.target;

    if (this.isCellEdit) {
      // Yè½´æ»å¨è·ç¦»è¶è¿tré«åº¦æ¶åæ¶ç®åç¼è¾ç¶æ
      if (this.scrollY === 0) {
        this.scrollY = target.scrollTop;
      }
      const offset = target.scrollTop - this.scrollY;
      if (offset > 40 || offset < -40) {
        this.cancelEditingStatus();
        this.scrollY = 0;
      }
    }

    const scrollLeft = target.scrollLeft;
    if (scrollLeft === 0) {
      if (target.clientWidth === target.scrollWidth) {
        this.setScrollViewClass('none');
      } else {
        this.setScrollViewClass('left');
      }
    } else if (scrollLeft + target.clientWidth === target.scrollWidth) {
      this.setScrollViewClass('right');
    } else {
      this.setScrollViewClass('middle');
    }

    if (this.fixHeader) {
      (<HTMLElement>this.fixHeaderContainerRefElement.nativeElement).scrollLeft = scrollLeft;
    }
  }

  private setScrollViewClass(position: string) {
    const element = this.tableViewRefElement.nativeElement;
    const className = 'devui-talbe-scorll-' + position;
    const elClassList = element.classList;
    if (!elClassList.contains(className)) {
      for (let index = 0; index < elClassList.length; index++) {
        const clName = elClassList[index];
        if (clName.startsWith('devui-talbe-scorll-')) {
          this.renderer.removeClass(element, clName);
        }
      }
      this.renderer.addClass(element, className);
    }
  }

  private unSubscription() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }

    if (this.colSubscription) {
      this.colSubscription.unsubscribe();
      this.colSubscription = null;
    }
  }

  private setupScrollEvent() {
    if (!this.subscription) {
      this.subscription = this.registerOnScrollStream(this.scrollStream)
        .subscribe(_ => this.onScrollChange());
    }
  }

  private registerOnScrollStream(scrollStream: EventEmitter<any>) {
    return scrollStream
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      );
  }

  onToggleChildrenTable(rowItem, status) {
    if (status === this.tableStatusEnum.open) {
      let loadChildrenResult = Promise.resolve(true);
      if (this.loadChildrenTable) {
        loadChildrenResult = this.loadChildrenTable(rowItem);
      }
      loadChildrenResult.then(() => {
        // å¼æ­¥å è½½å­è¡¨æ ¼æ¯æ£æ¥éä¸­ç¶æ
        if (rowItem.$checked && this.checkableRelation.downward) {
          this.setCheckedStatus(rowItem.children, rowItem.$checked);
        }
      });
    } else {
      this.childrenTableClose.emit(rowItem);
    }
  }

  private setChildrenToogleStatus(data, open) {
    return data.map(item => {
      if (item.children) {
        item.$isChildTableOpen = open;
        item.children = this.setChildrenToogleStatus(item.children, open);
      }
      return item;
    });
  }

  // åæ¢è¡¨å¤´çå­è¡¨æ ¼å±å¼æ¶èµ·
  onToggleAllChildrenTable(status) {
    if (status === this.tableStatusEnum.open) {
      let loadAllChildrenResult = Promise.resolve(true);
      if (this.loadAllChildrenTable) {
        loadAllChildrenResult = this.loadAllChildrenTable();
      }
      loadAllChildrenResult.then(() => {
        this.dataSource.forEach(item => {
          if (item.$checked && item.children) {
            this.setCheckedStatus(item.children, true);
          }
        });
        this.setChildrenToogleStatus(this.dataSource, status);
      });
    } else {
      this.setChildrenToogleStatus(this.dataSource, status);
      this.allChildrenTableClose.emit();
    }
  }

  cancelEditingStatus() {
    this.documentClickEvent.emit('cancel');
  }

  private collectCheckedRows(dist: Array<any>, source: Array<any>) {
    source.forEach(row => {
      if (row.$checked) {
        dist.push(row);
      }
      if (row.children) {
        this.collectCheckedRows(dist, row.children);
      }
    });
  }

  getCheckedRows() {
    if (this.checkableRelation.upward) {
      // å¦æchildrençéä¸­ç¶æå³èparentçéä¸­ç¶æ,åªéè¿åæå¤å±çæ°æ®
      return this.dataSource ? this.dataSource.filter(item => item.$checked || item.$halfChecked) : [];
    } else {
      // å¦æchildrençéä¸­ç¶æä¸å³èparentçéä¸­ç¶æ,éådataSource,å°ææçéä¸­è¡å¹³çº§è¿å
      const checkedRows = [];
      this.collectCheckedRows(checkedRows, this.dataSource);
      return checkedRows;
    }
  }
}
